exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".label[data-v-b33daece]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/css-loader?minimize!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b33daece","scoped":true,"hasInlineConfig":false}!/home/abuild/rpmbuild/BUILD/Portus-v2.3/~/vue-loader/lib/selector.js?type=styles&index=0!./modules/repositories/components/tag.vue
// module id = 303
// module chunks = 0